export default function resizeSvg(inSvgString, inWidth, inHeight) {
    return inSvgString
    .replace(/width="[^"]*"/, `width="${inWidth}"`)
    .replace(/height="[^"]*"/, `height="${inHeight}"`);
}
